import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'

import { appRoutes } from './routes-map'
import './scss/global.scss'
import { createQueryClient, createTrpcClient, trpc } from './trpc'

const rootElement = document.getElementById('root')

if (rootElement === null) {
  throw new Error('Missing #root element in index.html')
}

const queryClient = createQueryClient()
// No url: '/trpc' relative, which in dev is the Vite proxy to :8080 —
// same-origin, which is what makes the httpOnly cookies work without CORS.
const trpcClient = createTrpcClient()
const router = createBrowserRouter(appRoutes)

createRoot(rootElement).render(
  <StrictMode>
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </trpc.Provider>
  </StrictMode>,
)
